<template>
  <div class="tuolele-main-box">
    <div class="app-container app-margin-bottom20">
      <el-form ref="postForm" label-width="110px" style="width:70%" :model="tyyKnowledge" :rules="rules">
        <el-form-item label="*内容标题" prop="knowledge_title">
          <el-input v-model="tyyKnowledge.knowledge_title" placeholder="请输入知识点名称" />
        </el-form-item>
        <el-form-item label="*适用日期">
          <el-date-picker v-model="tyyKnowledge.begin_date" value-format="yyyy-MM-dd" type="date" placeholder="选择开始日期" />
          <span style="margin-left: 10px;margin-right: 10px;">至</span>
          <el-date-picker v-model="tyyKnowledge.end_date" value-format="yyyy-MM-dd" type="date" placeholder="选择结束日期" />
        </el-form-item>
        <el-form-item label="*知识点科目" prop="subject_id">
          <Select key="5" :selected.sync="tyyKnowledge.subject_id" :data="subjectLists" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="*适用年级" prop="grade_id">
          <Select key="5" :selected.sync="tyyKnowledge.grade_id" :data="gradeLists" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="*适用教材" prop="book_id">
          <text-book-select :subject-id="tyyKnowledge.subject_id" :selected.sync="tyyKnowledge.teaching_type" />
        </el-form-item>
        <h1>知识点信息</h1>
        <el-form-item label="*知识点梳理">
          <el-input v-model="tyyKnowledge.extra.analyze" type="textarea" :rows="6" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="*重难点解析">
          <el-input v-model="tyyKnowledge.extra.import" type="textarea" :rows="6" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="*上传视频">
          <upload-video :url="tyyKnowledge.extra.video" @updateUrl="uploadSuccess" />
        </el-form-item>
        <el-button v-if="isEdit" type="primary" @click="fnSubmitForm">提交</el-button>
      </el-form>
    </div>

  </div>
</template>

<script>

import UploadVideo from '@/components/toolbar/UploadVideo'
import Select from '@/components/Select'
import { validateRequire } from '@/utils/validate'
import commondata from '@/utils/commondata'
import TextBookSelect from '@/components/Select/TextBookSelect'

// import TeachingTypeSelect from '@/components/Select/TeachingTypeSelect'

export default {
  components: {
    Select,
    TextBookSelect,
    UploadVideo
  },
  data() {
    return {
      tyyKnowledge: {
        knowledge_id: '',
        knowledge_title: '',
        subject_id: '',
        grade_id: '',
        begin_date: '',
        end_date: '',
        teaching_type: '',
        extra: {
          analyze: '',
          import: '',
          video: ''
        }
      },
      isEdit: true,
      gradeCheckLists: [],
      subjectLists: commondata.TYY_SUBJECT_LISTS,
      gradeLists: commondata.GRADE_LISTS,
      rules: {
        knowledge_title: [{ validator: validateRequire, trigger: 'manual', message: '知识点名称' }],
        subject_id: [{ validator: validateRequire, trigger: 'manual', message: '知识点科目' }],
        grade_id: [{ validator: validateRequire, trigger: 'manual', message: '适合年级' }],
        book_id: [{ validator: validateRequire, trigger: 'manual', message: '适用教材' }]
      }
    }
  },
  watch: {
    'tyyKnowledge.subject_id': function(val) {
      this.tyyKnowledge.book_id = ''
    }
  },
  created() {
    this.isEdit = this.$route.query.isEdit != false
    this.tyyKnowledge.knowledge_id = this.$route.query.id || ''
    if (this.tyyKnowledge.knowledge_id) {
      this.fnGetKnowLedge()
    }
  },
  methods: {
    // 提交
    fnSubmitForm: function() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          if (!this.tyyKnowledge.extra.video || !this.tyyKnowledge.extra.analyze || !this.tyyKnowledge.begin_date || !this.tyyKnowledge.end_date) {
            this.$message({
              type: 'error',
              message: '请填写完整!'
            })
            return
          }
          this.tyyKnowledge.extra = JSON.stringify(this.tyyKnowledge.extra)
          this.$http.tyyEditKnowledgePoint(this.tyyKnowledge).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
              setTimeout(this.$router.push({ path: '/admin/tiyouyou/tyyKnowledgeSettingLists' }), 2000)
            }
          })
        }
      })
    },
    uploadSuccess(url) {
      this.tyyKnowledge.extra.video = url
    },
    fnGetKnowLedge() {
      this.$http.tyyGetKnowledgePointRow(this.tyyKnowledge).then(res => {
        this.tyyKnowledge.knowledge_title = res.data.knowledge_title
        this.tyyKnowledge.begin_date = res.data.begin_date
        this.tyyKnowledge.end_date = res.data.end_date
        this.tyyKnowledge.subject_id = res.data.subject_id
        this.tyyKnowledge.grade_id = res.data.grade_id
        this.tyyKnowledge.extra.analyze = res.data.extra.analyze
        this.tyyKnowledge.extra.import = res.data.extra.import
        this.tyyKnowledge.extra.video = res.data.extra.video || ''
        console.log(this.tyyKnowledge.extra.video)
        this.$nextTick(function() {
          this.tyyKnowledge.book_id = parseInt(res.data.book_id || '')
        })
      })
    }

  }
}
</script>

<style lang="scss" >

</style>
